import $ from 'jquery'
import axios from 'axios'
import get from 'lodash/get'
import urls from './urls'
import moment from 'moment'

const baseURL = get(
  window.Redwood,
  'baseURL',
  'https://api.c21redwood.test/api/v1'
)

let supportTeam = null

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

const token = document.head.querySelector('meta[name="csrf-token"]')
if (token) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
  console.error(
    'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token'
  )
}
window.axios = axios

const errorHandler = error => {
  // authentication errors should trigger session error
  if (
    error.response && (
      error.response.status === 429 ||
      error.response.status === 419 ||
      error.response.status === 401
    )
  ) {
    $('window').trigger('session-error', [error])
  }

  if (error.response && error.response.status === 500) {
    window.console && console.error(error)
    // window.location.replace('/#/pages/500')
  }

  return Promise.reject(error)
}

axios.interceptors.response.use(null, errorHandler)

const api = axios.create({
  baseURL
})

api.interceptors.response.use(null, errorHandler)

/**
 * Either update the CSRF token header with the given
 * token, or request the login form and read the request
 * token from the HTML and update it that way
 *
 * @param token Optionally, an explicit token to use
 */
export const refreshCsrfToken = token => {
  if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token
    $('#logout input[name="_token"]').val(token)
  } else {
    axios.get('login').then(response => {
      let token = $(response.data)
        .filter('meta[name="csrf-token"]')
        .attr('content')

      axios.defaults.headers.common['X-CSRF-TOKEN'] = token
      $('#logout input[name="_token"]').val(token)
    })
  }
}

export const saveAgentLandscapeImage = (agentId, fileId) =>
  api.post(urls.agents.landscapePhoto(agentId), { file_id: fileId })

export const saveAgentPortraitImage = (agentId, fileId) =>
  api.post(urls.agent.portraitPhoto(agentId), { file_id: fileId })

export const getRecentBusinessPlanActivity = () =>
  api.get(urls.businessPlan.recentActivity(), {
    params: {
      fields: 'broadcast'
    }
  })

export const logBusinessPlanActivity = activity =>
  api.post(urls.businessPlan.logActivity(), { activity })

export const saveBusinessPlanConfig = (userId, config, year, activate) =>
  api.put(urls.businessPlan.config(userId, year), { config, activate })

export const getBusinessPlanLeaderboard = (view, period, userId, year) =>
  api.get(urls.businessPlan.leaderboard(view, userId, year), {
    params: {
      period
    }
  })

export const getBusinessPlanLtmStats = (userId, year) =>
  api.get(urls.businessPlan.ltmStats(userId, year))

export const getBusinessPlanVideoFeed = (userId, year, forceVideoId) =>
  api.get(urls.businessPlan.videoFeed(userId, year), {
    params: {
      force_video_id: forceVideoId
    }
  })

export const approveBusinessPlanLtm = (userId, year) =>
  api.post(urls.businessPlan.approveLtm(userId, year))

export const getBusinessPlan = (userId, year) =>
  api.get(urls.businessPlan.config(userId, year))

export const getBusinessPlanPrepwork = (userId, year) =>
  api.get(urls.businessPlan.prepwork(userId, year))

export const getBusinessPlanIncomeGoal = (userId, year) =>
  api.get(urls.businessPlan.incomeGoal(userId, year))

export const markBusinessPlanNotCopiedInto = (userId, year) =>
  api.post(urls.businessPlan.notCopiedInto(userId, year))

export const getBusinessPlanHistory = (userId, year, key) =>
  api.get(urls.businessPlan.history(userId, year, key))

export const copyIntoBusinessPlan = (userId, year, fromYear) =>
  api.post(urls.businessPlan.copyIntoPlan(userId, year), {
    from_year: fromYear
  })

export const changeDomainName = (userId, website, domain) =>
  api.post(urls.users.websites.domain(userId), {
    website,
    domain
  })

export const countSimpleEngagements = (userId, type, period, leadSource) =>
  api.get(urls.businessPlan.engagements(userId), {
    params: {
      type,
      lead_source: leadSource,
      date: moment().toISOString(),
      period
    }
  })

export const incrementSimpleEngagements = (userId, type, leadSource, period) =>
  api.post(urls.businessPlan.engagements(userId), {
    type,
    date: moment().toISOString(),
    period,
    data: {
      lead_source: leadSource
    }
  })

export const decrementSimpleEngagements = (userId, type, leadSource, period) =>
  api.delete(urls.businessPlan.engagements(userId), {
    params: {
      type,
      lead_source: leadSource,
      date: moment().toISOString(),
      period
    }
  })

export const touchPowerHour = () =>
  api.post(urls.businessPlan.powerHour())

export const optOutOfBusinessPlan = (userId, year) =>
  api.post(urls.businessPlan.optOut(userId, year))

export const optIntoBusinessPlan = (userId, year) =>
  api.post(urls.businessPlan.optIn(userId, year))

export const rebuildTasks = (userId, year) =>
  api.post(urls.businessPlan.rebuildTasks(userId, year))

export const logRecruitingActivity = (field, count) =>
  api.post(urls.recruiting.logActivity(field), { count })

export const setClosingLeadSource = (closingId, leadSource) =>
  api.put(urls.businessPlan.closingLeadSource(closingId), {
    lead_source: leadSource
  })

export const dismissPrepworkWelcomeModal = (dismiss, userId) =>
  api.post(urls.users.dismissPrepworkWelcomeModal(userId), {
    dismiss: !!dismiss
  })

/**
 * @deprecated
 * @param date
 * @returns {Promise<{data: {}}>}
 */
export const getRecruitingTrackerStats = date =>
  Promise.resolve({
    data: {}
  })

export const searchRecruitingContacts = (query, params) =>
  api.post(urls.recruiting.contacts.search(), { query, params })

export const getDashboards = (userId, params) =>
  api.get(urls.dashboard.list(userId), { params })

export const loadWidget = (type, filter = {}, flush = false, cancelToken = null) =>
  api.post(urls.dashboard.widget(null, type), {
    type,
    filter,
    flush
  }, {
    cancelToken
  })

export const exportWidget = (type, filter = {}, cancelToken = null) =>
  api.post(urls.dashboard.export(), {
    type,
    filter
  }, {
    cancelToken
  })

export const claimAgent = agentId => api.post(urls.agents.claim(), { agentId })

export const unclaimAgent = agentId =>
  api.post(urls.agents.unclaim(), { agentId })

export const searchAgents = query => api.post(urls.agents.search(), { query })

export const embed = url => api.post(urls.cms.embed(), { url })

export const getTasks = (view, userId, page, pageSize, query) =>
  api.get(urls.tasks.list(view, userId), {
    params: {
      query,
      page,
      page_size: pageSize || 200
    }
  })

export const getProjectByConnection = (connection, projectsId) =>
  api.get(urls.projects.fetchByConnection(connection, projectsId))

export const getProject = (id, flush) =>
  api.get(urls.projects.fetch(id), {
    params: {
      flush
    }
  })

export const saveTask = task => api.post(urls.tasks.edit(task), task)

export const createTask = (task) =>
  api.post(urls.tasks.edit(), task)

export const deleteTask = task => api.delete(urls.tasks.delete(task))

export const countTasks = (view, userId) =>
  api.get(urls.tasks.count(view, userId))

export const markTaskComplete = task => api.post(urls.tasks.complete(task))

export const markTaskIncomplete = task => api.delete(urls.tasks.complete(task))

export const markGuideRead = guide => api.post(urls.support.markGuideRead(guide.id))

export const getMySupportTeam = () => {
  if (!supportTeam) {
    let promise = api.get(urls.support.team())
    promise.then((response) => {
      supportTeam = response.data
    })
    return promise
  } else {
    return new Promise((resolve, reject) => {
      resolve(supportTeam)
    })
  }
}

export const getCalendarItems = (start, end, calendars) =>
  api.get(urls.calendars.items(), {
    params: {
      start,
      end,
      calendars
    }
  })

// Reactions

export const getReactions = (params = {}) =>
  api.get(urls.reactions.list(), {
    params
  })

export const getReactionStatus = (reactableType, reactableId, type) =>
  api.get(urls.reactions.status(), {
    params: {
      reactable_type: reactableType,
      reactable_id: reactableId,
      type
    }
  })

export const toggleReaction = (reactableType, reactableId, type) =>
  api.post(urls.reactions.toggle(), {
    reactable_type: reactableType,
    reactable_id: reactableId,
    type
  })

export const toggleSupportShowAgentExperience = () =>
  api.post(urls.support.toggleShowAgentExperience())

export const searchSupport = (search, format) =>
  api.get(urls.support.search(), {
    params: {
      search,
      format: format || 'json'
    }
  })

export const sendSupportTicket = (ticket, context) =>
  api.post(urls.support.ticket(), {
    ticket,
    context
  })

export const getSupportTopics = (guideType) =>
  api.get(urls.support.topics(), {
    params: {
      guide_type: guideType
    }
  })

export const getMyApps = () =>
  api.get(urls.sso.me())

export const getAllApps = () =>
    api.get(urls.sso.apps())

export const getApp = (id, connection) =>
  api.get(urls.sso.app(id), {
    params: connection ? { connection } : {}
  })

export const updateMyApps = (apps, action = 'sync') =>
  api.post(urls.sso.apps(), {
      apps,
      action
  })

export const search = (query) =>
  api.post(urls.search.query(), {
    query
  })

export const registerRecruit = (recruit) =>
  api.post(urls.contacts.recruits.register(), recruit)

export const getMyListings = () =>
  api.get(urls.listings.me())

export const searchListings = (params) =>
  api.get(urls.listings.search(), {
    params
  })

export const getListingReimbursementStatus = (listingId) =>
  api.get(urls.listings.reimbursement(listingId))

export const applyForListingReimbursement= (listingId) =>
  api.post(urls.listings.reimbursement(listingId))

export const getListingMediaArchive = (mlsConnection, mlsId) =>
  api.get(urls.listings.mediaArchive(mlsConnection, mlsId))

export const notifyMarketing = (listingId) =>
  api.post(urls.listings.notifyMarketing(listingId))

export const takenDownListing = (listingId, takeDown) =>
  api.post(urls.listings.takenDownListing(listingId), {
    take_down: takeDown ? 1 : 0
  })

export const stopNotifyingMarketing = (listingId) =>
  api.delete(urls.listings.notifyMarketing(listingId))

export const getOfficeRoster = (id, flush) =>
  api.get(urls.offices.roster(id), {
    params: {
      flush
    }
  })

export const getRoster = (type) =>
  api.get(urls.roster.list(type))

export const searchRoster = (params) =>
  api.get(urls.roster.search(), {
    params
  })

export const getUserAccounts = (userId) =>
  api.get(urls.users.accounts(userId))

export const getDocuSignUser = (userId) =>
  api.get(urls.users.docusign(userId));

export const auditAddress = (userId, addressId, status, audit) =>
  api.post(urls.users.addresses.audit(userId, addressId), {
    status,
    audit
  })

export const dismissTasksIcsModal = (dismiss, userId) =>
  api.post(urls.users.dismissTasksIcsModal(userId), {
    dismiss: !!dismiss
  })

export const getCallCenter = (id) =>
  api.get(urls.callCenters.fetch(id))

export const toggleCallCenterMemberAvailable = (callCenterId, callCenterMemberId) =>
  api.post(urls.callCenters.member(callCenterId, callCenterMemberId))

export const fetchAndSave = (files, makePublic, attachableType, attachableId) =>
  api.post(urls.upload.fetch(), {
    files,
    public: makePublic,
    attachable_type: attachableType,
    attachable_id: attachableId
  })

export const getAttachments = (attachableType, attachableId, scope, page) =>
  api.get(urls.files.attachments.list(), {
    params: {
      attachable_type: attachableType,
      attachable_id: attachableId,
      scope,
      page: page || 1
    }
  })

export const setAttachmentScope = (attachmentId, scope) =>
  api.post(urls.files.attachments.scope(attachmentId), {
    name: scope
  })

export const getImages = (attachableType, attachableId, scope, page) =>
  api.get(urls.files.attachments.list(), {
    params: {
      types: 'images',
      attachable_type: attachableType,
      attachable_id: attachableId,
      scope,
      page: page || 1
    }
  })

export const removeAttachment = (attachmentId) =>
  api.delete(urls.files.attachments.show(attachmentId))

export const createLiveStream = (videoUrl, type) =>
  api.post(urls.videos.stream(type), {
    url: videoUrl
  })

export const createLiveEmbed = (embedUrl, attributes, type) =>
  api.post(urls.videos.embed(type), {
    url: embedUrl,
    attributes
  })

export const endLiveStream = (type) =>
  api.delete(urls.videos.stream(type))

export const verifyPassword = (password, userId) =>
  api.post(urls.users.verifyPassword(userId), {
    password
  })

export const saveTwoFactorAuthSecret = (password, code, userId) =>
  axios.create().post(urls.users.saveTwoFactorAuthSecret(userId), {
    password,
    one_time_password: code
  })

export const removeTwoFactorAuth = (code, userId) =>
  axios.create().post(urls.users.removeTwoFactorAuth(userId), {
    one_time_password: code
  })

export const getCampaigns = (slot, userId, limit) =>
  api.get(urls.campaigns.list(), {
    params: {
      slot,
      user: userId,
      limit
    }
  })

export const acknowledgeCampaign = (campaignRef, slot) =>
  api.post(urls.campaigns.acknowledge(campaignRef), {
    slot
  })

export const getNotes = (annotatableType, annotatableId) =>
  api.get(urls.notes.list(), {
    params: {
      annotatable_type: annotatableType,
      annotatable_id: annotatableId
    }
  })

export const createNote = (annotatableType, annotatableId, content) =>
  api.post(urls.notes.list(), {
    annotatable_type: annotatableType,
    annotatable_id: annotatableId,
    content
  })

export const updateNote = (note) =>
  api.put(urls.notes.edit(note), note)

export const deleteNote = (note) =>
  api.delete(urls.notes.edit(note))

export const getRecentNotifications = (userId) =>
  api.get(urls.notifications.list(userId))

export const markAllNotificationsRead = (userId) =>
  api.delete(urls.notifications.list(userId))

export const getAttendeeList = (eventId) =>
  api.get(urls.attendance.list(eventId))

export const saveEvent = (eventId, properties) =>
  api.post(urls.attendance.event(eventId), properties)

export const saveAttendeeStatus = (eventId, userId, status) =>
  api.post(urls.attendance.status(eventId, userId, status))

export const removeAttendee = (eventId, userId) =>
  api.delete(urls.attendance.remove(eventId, userId))

export const getGuides = (filter) =>
    api.get(urls.support.guides(), {
        params: filter
    })

export default api
